import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Fab,
  IconButton,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { Add } from "@mui/icons-material";
import { SnackAlertContext } from "../../../context/SnackAlertContext";
import { currencyFormat } from "../../../components/NewDetail/calculations/utils";
import CreateNewConsumableDialog from "./CreateNewConsumableDialog";
import UpdateConsumableDialog from "./UpdateConsumableDialog";

const DEFAULT_UPDATE_DIALOG_DATA = {
  open: false,
  consumable: null,
};
const Consumables = ({ search, status }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [consumables, setConsumables] = useState([]);
  const [createNewDialogOpen, setCreateNewDialogOpen] = useState(false);
  const [updateDialogData, setUpdateDialogData] = useState(
    DEFAULT_UPDATE_DIALOG_DATA
  );

  const getConsumables = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(`/consumables`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status == 200 || response.status === 201) {
        // navigate to order details page
        //orderDispatch({ type: "SET ORDER STATE", payload: initialOrder });
        setConsumables(response.data.consumables);
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getConsumables();
  }, []);

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
    >
      <Typography variant="h4" component="div">
        Consumables Catalog
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">ID</TableCell>
              <TableCell align="left">Description</TableCell>
              <TableCell align="left">UOM</TableCell>
              <TableCell align="left">Retail price</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {consumables.map((consumable, index) => {
              return (
                <TableRow
                  key={consumable.id}
                  onClick={() => {
                    setUpdateDialogData({ open: true, consumable });
                  }}
                >
                  <TableCell align="left">{consumable.id}</TableCell>
                  <TableCell align="left">{consumable.description}</TableCell>
                  <TableCell align="left">{consumable.uom}</TableCell>
                  <TableCell align="left">
                    {currencyFormat(consumable.retailPrice ?? 0)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "50px",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <Fab
          onClick={() => {
            setCreateNewDialogOpen(true);
          }}
          variant="extended"
          color="success"
        >
          <Add /> New
        </Fab>
      </div>
      <CreateNewConsumableDialog
        open={createNewDialogOpen}
        onClose={() => {
          setCreateNewDialogOpen(false);
        }}
        onSuccess={() => {
          getConsumables();
          setCreateNewDialogOpen(false);
          openSnackMessage("success", "Created");
        }}
      />
      <UpdateConsumableDialog
        open={updateDialogData.open}
        consumable={updateDialogData.consumable}
        onClose={() => {
          setUpdateDialogData(DEFAULT_UPDATE_DIALOG_DATA);
        }}
        onUpdated={() => {
          getConsumables();
          setUpdateDialogData(DEFAULT_UPDATE_DIALOG_DATA);
          openSnackMessage("success", "Updated");
        }}
        onDeleted={() => {
          getConsumables();
          setUpdateDialogData(DEFAULT_UPDATE_DIALOG_DATA);
          openSnackMessage("success", "Deleted");
        }}
      />
    </Box>
  );
};
export default Consumables;
